import React from "react";
import { Link } from "react-router-dom";
import { FileTextOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ActionBtn } from "./ActionBtn";

export const AppointmentItem = ({ appointment }) => {
  const {
    patientName,
    patientAge,
    appointmentType,
    status,
    time,
    appointment_id: id,
    clinician_name,
    session_date,
    patient_id,
    note_ehr_submitted,
    valid_appt_flag
  } = appointment;



  const isInProgress = status === "in-progress";
  const isScheduled = status === "scheduled";
  const navigate = useNavigate();

  const handleStartClick = (e, patient_id, id) => {

    e.stopPropagation();
    e.preventDefault();

    if (valid_appt_flag === false) return;

    navigate(`/patient/${patient_id}/session/${id}`, {
      state: {
        is_recording: true,
        valid_appt_flag,
      },
    });
  };

  const textColor = isInProgress
    ? "!text-white"
    : isScheduled
    ? "text-text"
    : "text-grayHighlight";

  return (
    <div className="flex justify-between gap-[60px] group cursor-pointer transition-all duration-200">
      {/* Time */}
      <span
        className={`flex w-20 justify-center items-center ${
          isInProgress ? "text-accent" : "text-grayHighlight"
        } group-hover:text-accent transition-colors duration-200`}
      >
        {time}
      </span>

      {/* Main content row */}
      <div className="flex w-full gap-x-4 items-center">
        {/* Card */}
        <Link
          to={`patient/${patient_id}/session/${id}`}
          state={{
            clinician_name: clinician_name,
            session_date: session_date,
            valid_appt_flag: valid_appt_flag,
          }}
          className={`w-full border border-grayHighlight rounded-lg p-4 ${
            isInProgress ? "bg-accent" : "bg-white"
          } group-hover:border-accent transition-all duration-200`}
        >
          <div className="flex justify-between items-center px-4">
            {[patientName, patientAge, appointmentType].map((text, i) => (
              <div
                key={i}
                className={`w-full ${textColor} group-hover:text-accent transition-colors duration-200`}
              >
                {text}
              </div>
            ))}
            <div
              className="flex items-center gap-x-2 select-none cursor-pointer"
              onClick={(e) => handleStartClick(e, patient_id, id)}
            >
              <ActionBtn status={status} noteEhrSubmitted={note_ehr_submitted} validApptFlag={valid_appt_flag} />
            </div>
          </div>
        </Link>

        {/* Summary (always takes space, content conditionally shown) */}
        <div className="w-[100px] min-w-[100px]">
          {!isScheduled && (
            <div
              className={`items-center gap-x-1 ${
                isInProgress ? "flex" : "hidden group-hover:flex"
              } transition-all duration-200`}
            >
              <FileTextOutlined className="text-accent text-[14px]" />
              <Link
                to={`patient/${patient_id}/session/${id}`}
                state={{
                  clinician_name: clinician_name,
                  session_date: session_date,
                  valid_appt_flag: valid_appt_flag,
                }}
                // to={`/session/${id}`}
                className="flex-1 text-accent font-inter text-[14px] leading-[20px] font-medium text-right underline hover:underline transition-all duration-200"
              >
                Summary
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
